import { SP } from "../../http/serviceportalApi";
import { useTranslations } from "../../hooks/useTranslations";
import Label from "../ui/Label";
import Panel from "../ui/Panel";
import styles from "./AdminUserInfos.module.css";

interface Props {
  user: SP.User & { firstName: string; lastName: string };
}

const AdminUserInfos = ({
  user: { name, firstName, lastName, email },
}: Props) => {
  const { i18n } = useTranslations();
  const displayName = name ? name : `${firstName} ${lastName}`;
  return (
    <Panel>
      <div className={styles.infos}>
        <div>
          <Label>{i18n.admin.user.infos.name}</Label>
          {displayName}
        </div>
        <div>
          <Label>{i18n.admin.user.infos.email}</Label>
          {email}
        </div>
      </div>
    </Panel>
  );
};

export default AdminUserInfos;
